class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    message = message.toLowerCase();
    console.log(message);
    if (
      message.includes("product") ||
      message.includes("overview") ||
      message.includes("about") ||
      message.includes("what is qshikshak") ||
      message.includes("qshikshak overview") ||
      message.includes("platform") ||
      message.includes("erp")
    ) {
      this.actionProvider.handleProductOverview();
      return;
    }
    if (
      message.includes("features") ||
      message.includes("capabilities") ||
      message.includes("what can it do") ||
      message.includes("functions") ||
      message.includes("modules") ||
      message.includes("tools") ||
      message.includes("benefits")
    ) {
      this.actionProvider.handleFeatures();
      return;
    }
    if (
      message.includes("demo") ||
      message.includes("book") ||
      message.includes("schedule") ||
      message.includes("trial") ||
      message.includes("walkthrough") ||
      message.includes("meeting")
    ) {
      this.actionProvider.handleBookDemo();
      return;
    }

    if (
      message.includes("support") ||
      message.includes("help") ||
      message.includes("issue") ||
      message.includes("problem") ||
      message.includes("customer care") ||
      message.includes("contact")
    ) {
      this.actionProvider.handleContact();
      return;
    }
    if (
      message.includes("price") ||
      message.includes("pricing") ||
      message.includes("cost") ||
      message.includes("plan") ||
      message.includes("subscription") ||
      message.includes("fees") ||
      message.includes("charges")
    ) {
      this.actionProvider.handlePricing();
      return;
    }
    if (
      message.includes("options") ||
      message.includes("help") ||
      message.includes("do for me")
    ) {
      return this.actionProvider.handleOptions({ withAvatar: true });
    }

    if (
      message.includes("talk") ||
      message.includes("speak") ||
      message.includes("real person") ||
      message.includes("call") ||
      message.includes("emergency") ||
      message.includes("contact")
    ) {
      return this.actionProvider.handleContact();
    }

    if (message.includes("attendance") || message.includes("roll call")) {
      this.actionProvider.handleAttendance();
      return;
    }

    if (message.includes("timetable") || message.includes("schedule") || message.includes("calendar")) {
      this.actionProvider.handleTimetable();
      return;
    }

    if (message.includes("exam") || message.includes("test") || message.includes("marks") || message.includes("report card") || message.includes("results") || message.includes("grades")) {
      this.actionProvider.handleExams();
      return;
    }

    if (message.includes("fee") || message.includes("payment") || message.includes("billing") || message.includes("accounting")) {
      this.actionProvider.handleFees();
      return;
    }

    if (message.includes("parent") || message.includes("communication") || message.includes("messages") || message.includes("notifications")) {
      this.actionProvider.handleParentCommunication();
      return;
    }

    if (message.includes("dashboard") || message.includes("analytics") || message.includes("reports")) {
      this.actionProvider.handleAnalytics();
      return;
    }



    if (message.includes("thanks") || message.includes("thank you")) {
      return this.actionProvider.handleThanks();
    }

    return this.actionProvider.handleOptions({ withAvatar: true });
  }
}

export default MessageParser;
